export default "__VITE_ASSET__C6DVEhF6__"